export const getRoleState = (state: any) => state.role
